module.exports = __webpack_public_path__ + "static/media/bling_sound.e895d7c8.mp3";